const round = (value, decimalPlaces = 2) => {
  const factor = Math.pow(10, decimalPlaces)
  const intermediary = value * factor
  const temp = Math.floor(intermediary)

  return intermediary - temp < 0.5 ? temp / factor : Math.ceil(intermediary) / factor
}

export function removeValueProportionallyFromValues(values, valueToRemove) {
  const numericValues = values.map(value => Math.max(Number(value) || 0, 0))
  const positiveIndexes = numericValues
    .map((value, index) => ({ value, index }))
    .filter(item => item.value > 0)

  if (!positiveIndexes.length) {
    return numericValues
  }

  const total = positiveIndexes.reduce((sum, item) => sum + item.value, 0)
  const totalToRemove = Math.min(Number(valueToRemove) || 0, total)

  if (!total || totalToRemove <= 0) {
    return numericValues
  }

  let remainingToRemove = round(totalToRemove, 2)
  const lastPositiveIndex = positiveIndexes[positiveIndexes.length - 1].index

  return numericValues.map((value, index) => {
    if (value <= 0) {
      return value
    }

    const proportionalValue =
      index === lastPositiveIndex ? remainingToRemove : round((value / total) * totalToRemove, 2)
    const valueToSubtract = Math.min(value, proportionalValue)
    remainingToRemove = round(remainingToRemove - valueToSubtract, 2)

    return round(value - valueToSubtract, 2)
  })
}
